import Cookies from "js-cookie";
import axios from "./config";
import { jwtDecode } from "jwt-decode";

interface DecodedToken {
  emp_id: string;
}

export function getHeader() {
  const token = Cookies.get("token") || "";
  const header = {
    Authorization: token,
  };
  return header;
}

const getUserInfo = () => {
  const token = Cookies.get("token");

  if (!token) {
    throw new Error("Authorization token not found");
  }

  return jwtDecode<DecodedToken>(token);
};

export const getSpecificCustomer = async (id: string): Promise<any> => {
  let url = `admin/customers/${id}`;
  const response = await axios.get<any>(url, {
    headers: getHeader(),
  });
  return response.data;
};

export const updateCustomer = async (
  formData: any,
  id: string
): Promise<any> => {
  let url = `/admin/customers/${id}`;
  const response = await axios.put<any>(url, formData, {
    headers: {
      ...getHeader(),
      "Content-Type": "application/json",
    },
  });
  return response.data;
};
